var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgINutrition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.684 41.188c0.146-4.908-2.524-6.756-5.78-7.977-1.082 4.199 1.904 7.693 5.78 7.977z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.421 19.273c2.076-4.445 0.356-7.211-2.16-9.618-2.641 3.432-1.283 7.82 2.16 9.618z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.592 31.647c-0.143-4.905 2.524-6.761 5.782-7.977 1.078 4.197-1.906 7.69-5.782 7.977z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.592 39.212c-0.143-4.905 2.524-6.756 5.782-7.975 1.078 4.196-1.906 7.69-5.782 7.975z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.592 24.085c-0.143-4.907 2.524-6.763 5.782-7.982 1.078 4.201-1.906 7.693-5.782 7.982z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.684 33.624c0.146-4.905-2.524-6.761-5.78-7.977-1.082 4.197 1.904 7.691 5.78 7.977z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.684 26.062c0.146-4.908-2.524-6.763-5.78-7.984-1.082 4.203 1.904 7.692 5.78 7.984z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.453 63.069h-26.311l13.157-22.796 13.154 22.796zM23.369 60.050h15.858l-7.929-13.735-7.929 13.735z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.843 47.54l55.741-15.164-0.828-3.063-55.745 15.166z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.176 0.634c0 0 0.408 8.041 7.456 7.359 0 0 0.795-6.718-7.456-7.359z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.555 26.787c-0.736 1.042-1.964 1.716-3.339 1.716-1.123 0-2.223-0.528-2.965-1.268-1.518-1.656-3.486-5.358-3.486-5.358-1.103-2.239-1.694-3.971-1.694-5.722 0-3.73 3.019-6.965 6.759-6.965 1.842 0 3.505 0.738 4.726 1.93 1.222-1.193 2.882-1.93 4.724-1.93 3.739 0 6.758 3.235 6.758 6.965 0 1.751-0.592 3.483-1.694 5.722 0 0-1.968 3.701-3.486 5.358-0.742 0.74-1.842 1.268-2.966 1.268-1.377-0.001-2.603-0.674-3.338-1.716z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgINutrition);
export default __webpack_public_path__ + "static/media/i-nutrition.fb1cfc60.svg";
export { ForwardRef as ReactComponent };